"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PreviewAPI = _interopRequireDefault(require("../api/PreviewAPI"));

var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));

var Actions = _AppConstants.default.ActionTypes;
var previewAPI = new _PreviewAPI.default();
var _default = {
  previewWebsite: function previewWebsite(websiteUrl) {
    return function (dispatch) {
      dispatch({
        type: Actions.FETCH_PREVIEW_STARTED
      });
      previewAPI.getDesktopPreview(websiteUrl).then(function (response) {
        return dispatch({
          type: Actions.DESKTOP_WEBSITE_PREVIEWED,
          payload: response.responseJSON
        });
      }, function () {
        return dispatch({
          type: Actions.DESKTOP_WEBSITE_PREVIEWED_ERROR
        });
      });
      previewAPI.getMobilePreview(websiteUrl).then(function (response) {
        return dispatch({
          type: Actions.MOBILE_WEBSITE_PREVIEWED,
          payload: response.responseJSON
        });
      }, function () {
        return dispatch({
          type: Actions.MOBILE_WEBSITE_PREVIEWED_ERROR
        });
      });
    };
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/actions/PreviewActionCreator.js
// module id = 313
// module chunks = 0